








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { TaxBasisAssessmentDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxTaxBasisAssessment extends Vue {
  private types: TaxBasisAssessmentDto[] | null = [];
  public selectedType = new TaxBasisAssessmentDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: TaxBasisAssessmentDto) {
    this.$emit("taxBasisAssessmentSelected", type);
  }

  public setSelected(type: TaxBasisAssessmentDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .taxBasisAssessment_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
